import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPolicy = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#737373",
		d: "M12.9 1.5c3.96 0 5.94 0 7.17 1.23S21.3 5.94 21.3 9.9v4.2c0 3.96 0 5.94-1.23 7.17s-3.21 1.23-7.17 1.23h-2.1c-3.96 0-5.94 0-7.17-1.23S2.4 18.06 2.4 14.1V9.9c0-3.96 0-5.94 1.23-7.17S6.84 1.5 10.8 1.5zM7.65 13.313a.787.787 0 0 0 0 1.575h5.25a.788.788 0 0 0 0-1.575zm0-4.2a.788.788 0 0 0 0 1.575h8.4a.787.787 0 0 0 0-1.576z"
	})
});
export default SvgPolicy;
